import { getSecurityId } from 'reducers/users';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { ROLES } from 'utils/constants';
import get from 'lodash/get';
import API from 'services/api';
import { setLoading, showSnackbar, toggleModal } from 'reducers/ui';
import { errorHandler } from 'utils/errorMessages';
import { actions as customerActions } from 'containers/Pages/People/Customers/Modules/dataGridTable';
import { actions as customerFilterActions } from 'containers/Pages/People/Customers/Modules/filters';
import { nameSpace } from 'containers/Pages/People/Customers/Modules/nameSpace';
import { actions as embeddedFormActions } from 'modules/embeddedForms/reducer';

export function* fetchCustomerListSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { filters, from } = payload;
    const securityCompanyId = yield select(getSecurityId);
    const options = {
      securityCompanyId,
      roles: [ROLES.CLIENT.id],
      archived: get(filters, 'archived', false),
      businessClientId: get(filters, 'businessClient'),
      search: get(filters, 'search'),
      from,
    };
    const { data } = yield call(API.fetchUserList, options);
    if (data.data !== null) {
      const totalEntries = get(data, 'meta.total');
      yield put(customerActions.setGridList({ list: data.data, totalEntries }));
    }
    yield put(customerFilterActions.setFilterKey(false));
    yield put(customerActions.setForceRefresh(false));
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}

export function* fetchCustomerSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id } = payload;
    const { data } = yield call(API.fetchUserDetail, id);
    if (data.data) {
      yield put(customerActions.setGridRowDetails({ details: data.data }));
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* createCustomerSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { customerData, embeddedForm } = payload;
    const { status, data } = yield call(API.addUser, customerData);
    if (status === 200 && embeddedForm) {
      yield put(
        embeddedFormActions.setEmbeddedFormDetails({
          formType: nameSpace,
          details: data.data,
        }),
      );
      // pass this info into the embedded form state
    }
    if (!embeddedForm) yield put(toggleModal(nameSpace));
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}
export function* updateCustomerSaga({ payload }) {
  try {
    yield put(setLoading(true));
    const { id, customerData } = payload;
    const { status } = yield call(API.updateUser, id, customerData);
    if (status === 200) {
      yield put(toggleModal(nameSpace));
      yield call(fetchCustomerSaga, { payload: { id } });
    }
  } catch (err) {
    yield put(
      showSnackbar({
        typeOfSnackbar: 'error',
        message: errorHandler(err),
      }),
    );
  }
  yield put(setLoading(false));
}

export function* customerSagas() {
  yield takeLatest(customerActions.fetchGridList, fetchCustomerListSaga);
  yield takeLatest(customerActions.fetchGridRowDetails, fetchCustomerSaga);
  yield takeLatest(customerActions.createRowEntry, createCustomerSaga);
  yield takeLatest(customerActions.updateRowEntry, updateCustomerSaga);
}
